// Centralised Personal Action Plan questionnaire taxonomy. Used by /blueprint/intake.

export const BLUEPRINT_SECTIONS = [
  {
    id: "identity_signal",
    title: "Identity Signal",
    explanation:
      "Understand who you are beneath performance, pressure, and external expectations.",
    questions: [
      { id: "name_on_blueprint", label: "What name should appear on your Personal Action Plan?", placeholder: "Your name", short: true },
      { id: "building_becoming", label: "What are you currently building, becoming, or trying to clarify?" },
      { id: "ready_for_shift", label: "What part of your life feels most ready for a shift?" },
      { id: "people_come_for", label: "What do people naturally come to you for?" },
      { id: "others_dont_see", label: "What do you know about yourself that others may not fully see yet?" },
      { id: "no_longer_perform", label: "What version of yourself are you no longer willing to keep performing?" },
      { id: "ready_to_claim", label: "What do you feel you are finally ready to admit, claim, or express?" },
    ],
  },
  {
    id: "energy_audit",
    title: "Energy Audit",
    explanation: "Identify force, flow, drains, expansion points, and hidden energy leaks.",
    questions: [
      { id: "currently_forcing", label: "Where are you currently forcing?" },
      { id: "drains", label: "What drains your energy consistently?" },
      { id: "energy_giving", label: "What gives you energy even when it takes effort?" },
      { id: "saying_yes_misaligned", label: "What do you keep saying yes to that no longer feels aligned?" },
      { id: "easier_if_stopped_proving", label: "What would become easier if you stopped trying to prove yourself?" },
      { id: "pulls_back_old_version", label: "What patterns, environments, or people pull you back into an older version of yourself?" },
      { id: "most_yourself", label: "When do you feel most like yourself?" },
    ],
  },
  {
    id: "story_origin",
    title: "Story and Origin",
    explanation: "Extract lived experience, pain, transformation, and wisdom that can become part of your brand, message, or direction.",
    questions: [
      { id: "shaped_you", label: "What experience shaped the person you are becoming?" },
      { id: "challenge_taught", label: "What challenge taught you something valuable?" },
      { id: "story_into_wisdom", label: "What part of your story do you feel ready to turn into wisdom?" },
      { id: "want_understood", label: "What do you want people to understand after hearing your story?" },
      { id: "lived_transformation", label: "What transformation have you lived that others could benefit from?" },
      { id: "survived_rebuilt", label: "What have you survived, rebuilt, or outgrown that changed how you see life?" },
      { id: "repeating_lesson", label: "What lesson keeps repeating in your life until you finally integrate it?" },
    ],
  },
  {
    id: "audience_resonance",
    title: "Audience and Resonance",
    explanation: "Clarify who you are naturally meant to reach, serve, inspire, teach, support, or build for.",
    questions: [
      { id: "called_to_serve", label: "Who do you feel most called to serve, support, teach, inspire, or build for?" },
      { id: "their_struggle", label: "What are they struggling with?" },
      { id: "they_want_cant_articulate", label: "What do they deeply want but may not know how to articulate?" },
      { id: "why_trust_you", label: "Why would they trust you?" },
      { id: "want_them_to_feel", label: "What do you want them to feel after encountering your work?" },
      { id: "resonates_with_you", label: "What kind of person naturally resonates with your story, energy, or perspective?" },
      { id: "want_them_to_stop_forcing", label: "What do you want people to stop forcing after they experience your work?" },
    ],
  },
  {
    id: "offer_value",
    title: "Offer and Value",
    explanation: "Clarify the practical value that can become a product, service, message, movement, or next chapter.",
    questions: [
      { id: "can_offer_now", label: "What skill, insight, service, product, or experience can you offer right now?" },
      { id: "result_help_toward", label: "What result can you help someone move toward?" },
      { id: "simplest_offer", label: "What is the simplest version of your offer?" },
      { id: "what_makes_different", label: "What makes your perspective different?" },
      { id: "proof_credibility", label: "What proof, experience, or credibility do you already have?" },
      { id: "natural_problem_solving", label: "What problem do you solve in a way that feels natural to you?" },
      { id: "without_pretending", label: "What could you offer without pretending to be further along than you are?" },
    ],
  },
  {
    id: "frequency_brand",
    title: "Frequency and Brand Definition",
    explanation: "Identify the emotional, visual, verbal, and energetic signature of your brand or next chapter.",
    questions: [
      { id: "energy_words", label: "What words describe the energy of your brand or next chapter?" },
      { id: "never_feel_like", label: "What words should your brand never feel like?" },
      { id: "aligned_visuals", label: "What colors, environments, visuals, or symbols feel aligned?" },
      { id: "brand_register", label: "Should your brand feel luxury, healing, bold, spiritual, strategic, grounded, artistic, educational, or something else?" },
      { id: "phrase_known_for", label: "What phrase, belief, or message do you want to be known for?" },
      { id: "if_room_feel_like", label: "If your brand were a room, what would it feel like when someone walked in?" },
      { id: "trust_in_first_seconds", label: "What should people trust about you within the first few seconds of encountering your work?" },
    ],
  },
  {
    id: "next_aligned_move",
    title: "Next Aligned Move",
    explanation: "Turn reflection into practical direction. Identify whether you may need deeper consultation or implementation support.",
    questions: [
      { id: "one_thing_next", label: "What is the one thing you know you need to do next?" },
      { id: "blocking", label: "What has been blocking you from doing it?" },
      { id: "support_to_move_faster", label: "What support would help you move faster?" },
      { id: "interest_in_consulting", label: "Are you interested in deeper consulting or implementation support?", short: true, placeholder: "Yes / Maybe / Not right now" },
      { id: "anything_else_for_cyrus", label: "Anything else you want Cyrus to know before your Personal Action Plan is reviewed?" },
      { id: "what_makes_valuable", label: "What would make this Personal Action Plan feel valuable and accurate to you?" },
      { id: "want_more_clarity_on", label: "What would you like to receive more clarity on when Cyrus sends your completed Personal Action Plan?" },
    ],
  },
];
